module.exports = __webpack_public_path__ + "static/activity-zones-1d5fd11ac0c55567faca683e68ad36e4.png";